/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const whatsAppAiThreadStateDataActivityStateSchema = z.enum(['idle', 'queued', 'thinking'])

export type WhatsAppAiThreadStateDataActivityStateSchema = z.infer<typeof whatsAppAiThreadStateDataActivityStateSchema>
